import Polyfill from "./Polyfill";

/**
 * this class is the basic modal of Event Gallery.
 */
export default class Overlay {

    constructor() {
        this.myDiv = null;
        this.background = null;
        this.$body = jQuery('body');
        this.onClosed = undefined;
        this.onLoad = undefined;
        this.repositionTimer = null;
        this.windowWidth = 0;
    }

    /**
     * opens an overlay. The content can be a url or content.
     * Url start with http or /
     *
     * @param dataUrl
     */
    openOverlay(dataUrl) {

        this.myDiv = jQuery('<div id="eventgallery-overlay"><i class="egfa egfa-2x egfa-cog egfa-spin"></i></div>');
        this.background = jQuery('<div id="eventgallery-overlay-background"></div>');
        this.background[0].onclick = () => {this.closeOverlay()};

        this.myDiv.css( {
            'opacity': '1 !important',
            'position': 'absolute',
            'max-width' : '100%'
        });

        this.$body.append(this.background);
        this.$body.append(this.myDiv);

        this.reposition(true);

        if (dataUrl.startsWith('http') || dataUrl.startsWith('/')) {
            Overlay._getRemoteData(dataUrl, (data) => {
                this._addContent(data);
            })
        } else {
            this._addContent(`<button class="btn-close-overlay eventgallery-close-overlay"><i class="egfa egfa-2x egfa-times-circle"></i></button>` + dataUrl);
        }


        jQuery(window).on('resize.overlay', () => {
            this._setRositionTimer(false);
        });
    }

    /**
     * triggers a timeout for the repositioning. This will avoid too much flickering.
     *
     * @param force
     * @private
     */
    _setRositionTimer(force) {
        if (this.repositionTimer) {
            clearTimeout(this.repositionTimer)
        }
        this.repositionTimer = setTimeout(() => this.reposition(force), 500);
    }

    static _getRemoteData(url, callback) {
        jQuery.ajax({url: url}).done(callback);
    }

    /**
     * moves the given content into the content overlay. Executes the onload method when finished.
     *
     * @param content
     * @private
     */
    _addContent(content) {
        this.myDiv.html(content);

        let elements = this.myDiv[0].getElementsByClassName('eventgallery-close-overlay');
        for(let i=0; i<elements.length;i++) {
            elements[i].onclick = () => {this.closeOverlay()};
        }

        this.reposition(true);

        if (this.onLoad !== undefined) {
            this.onLoad();
        }

        document.dispatchEvent(Polyfill.createNewEvent('eventgallery-images-added'));
    }

    /**
     * Closes the overlay and fires the onclose method if defined.
     */
    closeOverlay() {
        jQuery(window).off('.overlay');
        this.myDiv.fadeOut(150, () => {
            jQuery(this.myDiv).remove();
                this.background.fadeOut(200, () => {
                    jQuery(this.background).remove();
                    if (this.onClosed !== undefined) {
                        this.onClosed();
                    }
            });
        });
    }

    /**
     * Move the overlay to a good position.
     *
     * @param force defines if we force the reposition. If set to false, we do it only in case the width of the window changed.
     */
    reposition(force) {

        if (this.repositionTimer !== null) {
            clearTimeout(this.repositionTimer);
        }

        let maxWidth = jQuery(window).width();

        if (!force) {
            if (this.windowWidth === maxWidth) {
                return;
            }
        }

        this.windowWidth = maxWidth;

        this.myDiv.hide();

        this.myDiv.css( {
            'top': 0,
            'left': 0
        });

        let maxHeight = jQuery(window).height(),
            width = this.myDiv.outerWidth(),
            height = this.myDiv.outerHeight(),
            scrollTop = jQuery(window).scrollTop(),
            left = 0,
            top = scrollTop;

        if (maxWidth-width>0) {
            left = (maxWidth - width) / 2;
        }

        if (maxHeight - height > 0) {
            top = scrollTop + (maxHeight - height) / 2;
        }

        this.myDiv.css( {
            'top': top,
            'left': left
        });

        this.myDiv.show();
    };
}
